import React from "react";
import styles from "./HeroSection.module.css";
import profile from "../images/image.svg";
import customer from "../images/Customer profile.svg";
import background from "../images/background.svg"

const HeroSection = () => {
  return (
    <section className= {styles.hero}>
      <div className={`container ${styles.container}`} >
        <div className="row">
          <div className="col-lg-6 col-md-12 col-12 ">
            <h1 className={` col-lg-12 ${styles.heading}`}>
              Empower your customer engagement strategy With Buzzcom's
              cutting-edge chat feature
            </h1>
            <p className={styles.text}>
              Experience seamless and uninterrupted communication with our
              exceptional software, enabling you to initiate chats from
              anywhere, anytime.
            </p>
            <div className={styles.stats}>
              <div>
                <img src={customer}
                className={styles.customer} />
              </div>
              <div className={styles.profileDiv}>
                <span className={styles.number}>5,670</span>
                <p className={styles.textUser}>Happy Customers</p>
              </div>
            </div>
            <button className={styles.cta}>Start Chatting Now</button>
          </div>
          <div className="col-lg-6">
            <div className={styles.imageContainer}>
                <img src={background} className={styles.background}/>
              <img src={profile} alt="Hero" className={styles.heroImage} />
            </div>
          </div>
        </div>
      </div>
      </section>
  );
};

export default HeroSection;
